export default {
      id: "ozon-usage",
      viewBox: "0 0 169 169",
      url: "static/docker-35e621d613051bbda5b8b67fc5bb152e/images/" + "sprite.svg#ozon-usage",
      toString: function () {
        return this.url;
      }
    }